export default __webpack_public_path__ + "static/media/Logo.09ee7eda.png";